import React from 'react';

import { FormGroup } from '@material-ui/core';

export interface ControlGroupProps {
  children: React.ReactNode;
  row?: boolean;
}

export function ControlGroup(props: ControlGroupProps): JSX.Element {
  const { children, row = false } = props;

  return <FormGroup row={row}>{children}</FormGroup>;
}
